import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import i18n from './i18n'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引入深黑蓝色调主题
import './assets/styles/theme.css'

Vue.use(ElementUI);

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
